import { Box, Button, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import React, { useContext } from 'react';
import { ContextModal } from '@/data/context/content';
export const CatalogEntryButtonFilterBy = () => {
	const context = useContext(ContextModal);
	const { state, onSetOpen } = context || {};

	return (
		<Box
			display={'flex'}
			justifyContent={'space-between'}
			alignItems={'center'}
			marginBottom={'16px'}
		>
			<Typography component={'h4'} sx={{ color: '#707070', fontSize: 'var(--font-size-body)' }}>
				{state?.total} {'resultados'}
			</Typography>
			<Button
				startIcon={<FilterListIcon />}
				variant="outlined"
				onClick={() => onSetOpen?.(!state?.open)}
				sx={{
					bgcolor: '#F1F1F1',
					border: '1px solid #D9D9D9',
					height: '46px',
					width: '213px',
					borderRadius: '22px',
					color: '#2C2C2C',
					fontWeight: 'bold',
					fontSize: 'var(--font-size-body)',
					'&:hover': {
						bgcolor: '#F1F1F1',
						color: '#2C2C2C',
						border: '1px solid #D9D9D9',
					},
				}}
			>
				{'Filtrar por'}
			</Button>
		</Box>
	);
};
